<template>
  <section>
    <supplier-transactions />
    <router-view v-slot="{ Component }">
      <sidebar
        :isPanelOpen="$route.meta.showSidebar"
        @closeSidebarPanel="$router.push({ name: 'Supplier Payment History' })"
        position="right"
      >
        <div class="grid gap-4">
          <div
            class="
              flex
              justify-between
              border-b-2 border-gray-200
              -m-4
              px-4
              py-2
              items-center
              mb-4
            "
          >
            <p class="font-semibold">{{ $route.meta.displayName }}</p>
            <router-link
              :to="{
                name: 'Supplier Payment History',
                params: {
                  id: $route.params.id,
                },
              }"
            >
              <button title="Close Sidebar" class="block justify-self-end">
                <img
                  src="../assets/cross-primary.svg"
                  alt="Close Sidebar"
                  width="24"
                  height="24"
                />
              </button>
            </router-link>
          </div>
          <component :is="Component" />
        </div>
      </sidebar>
    </router-view>
  </section>
</template>
<script>
import SupplierTransactions from '../components/SupplierTransactions.vue';
import Sidebar from '../components/Sidebar.vue';

export default {
  name: 'PaymentHistorySuppliers',
  components: {
    SupplierTransactions,
    Sidebar,
  },
  data() {
    return {};
  },
  mounted() {},
  methods: {},
};
</script>
